import { createColumnHelper } from '@tanstack/react-table';

import { Timestamp } from '@/components/date-time';
import { Badge } from '@/components-new/badge';
import { DataPaginator } from '@/components-new/data-paginator';
import { DataTable, useDataTable } from '@/components-new/data-table';
import { NotificationHistoryChannel, NotificationHistoryEntry } from '@/features/notification-history/types/notification-history-entry';

const channelBadgeColor: Record<NotificationHistoryChannel, 'blue' | 'purple' | 'zinc'> = {
  Email: 'blue',
  Push: 'purple',
  InApp: 'zinc'
};

type NotificationHistoryTableProps = {
  entries: NotificationHistoryEntry[];
};

const columnHelper = createColumnHelper<NotificationHistoryEntry>();

export const NotificationHistoryTable = ({ entries }: NotificationHistoryTableProps) => {
  const columns = [
    columnHelper.accessor('channel', {
      header: 'Channel',
      cell: info => <Badge color={channelBadgeColor[info.getValue()]}>{info.getValue()}</Badge>
    }),
    columnHelper.display({
      id: 'recipient',
      header: 'Recipient',
      cell: ({ row }) => (
        <div className="text-sm">
          {row.original.recipientName && <p className="font-medium text-gray-900">{row.original.recipientName}</p>}
          <p className="text-gray-500">{row.original.recipient}</p>
        </div>
      )
    }),
    columnHelper.accessor('subject', {
      header: 'Subject',
      cell: info => <p className="max-w-xs whitespace-pre-line break-words text-sm font-medium text-gray-900">{info.getValue()}</p>
    }),
    columnHelper.accessor('body', {
      header: 'Body',
      cell: info => <p className="line-clamp-2 max-w-md whitespace-pre-line text-sm text-gray-600">{info.getValue()}</p>
    }),
    columnHelper.accessor('sentAt', {
      header: 'Sent At',
      cell: info => <Timestamp wordBreak="break-word" color="text-strong" value={info.getValue()}/>
    })
  ];

  const table = useDataTable({
    data: entries,
    columns,
    enablePagination: true
  });

  return (
    <>
      <DataTable table={table}/>
      <DataPaginator className="pt-2" table={table}/>
    </>
  );
};
